import angular from 'angular';
import referralKiwiSelectError from './referralKiwiSelectError';

export default angular
  .module('components.referralKiwiSelectError', [])
  .component('referralKiwiSelectError', referralKiwiSelectError).name;
